import { render } from "./InputErrors.vue?vue&type=template&id=6748e955"
import script from "./InputErrors.vue?vue&type=script&lang=js"
export * from "./InputErrors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__